<ng-container *ngIf="isLoading">
  <div style="width:200px; margin:0 auto;"><p-progressSpinner></p-progressSpinner> </div>
</ng-container>

<ng-container *ngIf="!isLoading && pagina">
  <div class="row">
    <div class="card card-xl-stretch mb-xl-8 container">
      <h1 class="page-title">
        <a (click)="voltarPagina()" class="cursor-pointer" style="margin-right: 10px;">
          <img style="width: 35px; vertical-align: middle;" src="./assets/img/back-button.png">
        </a>
        {{ pagina.nomePagina }}
      </h1>
      <div class="page-content">


        <div class="image-container">
          <img
            class="conteudo-image"
            [src]="imagemUrl"
            alt=""
          >
        </div>


        <div class="page-description" [innerHTML]="pagina.descricao"></div>
      </div>
      <details style="margin: 1% 3%" *ngFor="let topico of pagina.topicos">
        <summary class="p-summary">
          {{ topico.titulo }}
        </summary>

        <ng-container *ngIf="topico.titulo.includes('ACOLHIMENTOS') || topico.titulo.includes('Acolhimento'); else conteudoPadrao">
          <div class="p-descricao-topico" style="padding: 15px 20px;">
            <ul>
              <li>
                <a routerLink="/comissao-gams/canal-gams">Acesse aqui o formulário para contato com o grupo de Apoio e Assistência às Magistradas, Servidoras e Colaboradoras da Seção Judiciária do Rio Grande do Norte em situação de violência doméstica e familiar </a>
              </li>
              <li>
                <a
                  [href]="contatosMulherUrl"
                  target="_blank"
                >
                  Acesse aqui os contatos dos serviços de atendimento à mulher.
                </a>
              </li>
            </ul>
          </div>
        </ng-container>

        <ng-template #conteudoPadrao>
          <p class="p-descricao-topico" [innerHTML]="topico.descricaoTopico"></p>
        </ng-template>
      </details>

      <p style="align-self: flex-end; margin: 3%; font-weight: 400; font-size: 1.2rem">Responsável: {{pagina.responsavel}}</p>
    </div>
  </div>
</ng-container>



